import { ReactNode, useContext, useMemo } from 'react';
import { usePageScroll, usePageView } from '../hooks';
import AdobeAnalyticsContext from './AdobeAnalyticsContext';
import { AdobeAnalyticsConst } from '@/hooks/AdobeAnalyticsHooks/adobeAnalyticsConstants/adobeAnalyticsConstants';
import { useLinkClick } from '@/hooks/AdobeAnalyticsHooks/linkClick/useLinkClick';
import { useOnSiteSearch } from '@/hooks/AdobeAnalyticsHooks/onSiteSearch/useOnSiteSearch';
import { useRegistrationForm } from '@/hooks/AdobeAnalyticsHooks/RegistrationForm/useRegistrationForm';
interface AnalyticsProviderProps {
  children: ReactNode;
}
const AdobeAnalyticsProvider = ({ children }: AnalyticsProviderProps) => {
  const { trackPageView } = usePageView();
  const { trackScrollEvent } = usePageScroll();
  const { trackLinkClick } = useLinkClick();
  const { trackUserRegistration } = useRegistrationForm();
  const { trackOnSiteSearch } = useOnSiteSearch();

  const value = useMemo(
    () => ({
      trackPageView,
      trackScrollEvent,
      trackUserRegistration,
      trackLinkClick,
      trackOnSiteSearch,
      adobeAnalyticsConst: AdobeAnalyticsConst,
    }),
    [trackPageView, trackScrollEvent, trackUserRegistration, trackLinkClick, trackOnSiteSearch, AdobeAnalyticsConst],
  );
  return <AdobeAnalyticsContext.Provider value={value}>{children}</AdobeAnalyticsContext.Provider>;
};

export const useAdobeAnalytics = () => {
  const context = useContext(AdobeAnalyticsContext);
  if (!context) {
    throw new Error('useAdobeAnalytics must be used within an AdobeAnalyticsProvider');
  }
  return context;
};

export default AdobeAnalyticsProvider;
